/*
 * Copyright (c) 2020 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned
 * by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React, { Component } from 'react';
import SLAContainer from './SLAContainer';

/**
 * Class that renders the SLA "submit success" text within our SLAContainer component.
 */
class SLASuccess extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <SLAContainer>
        <h3>Thank you. Your response has been recorded.</h3>
        <p>
          If the acceptance of this software license agreement was made in error, please contact
          Honeywell Voice Technical Support.
        </p>
        <p>You may now close this browser window.</p>
      </SLAContainer>
    );
  }
}

export default SLASuccess;
